/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { BuildingRow__BuildingFragmentDoc } from '../../buildings/Buildings.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmCompanyBuildingsBox__BuildingFragment = { __typename: 'Building', id: string, title: string, createdAt: any, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null } };

export type LinkBuildingToCrmOrganisationMutationVariables = Types.Exact<{
  buildingId: Types.Scalars['ID']['input'];
  crmOrganisationId: Types.Scalars['ID']['input'];
}>;


export type LinkBuildingToCrmOrganisationMutation = { linkBuildingToCrmOrganisation: { __typename: 'LinkBuildingToCrmOrganisationResult', ok: boolean } };

export const CrmCompanyBuildingsBox__BuildingFragmentDoc = gql`
    fragment CrmCompanyBuildingsBox__Building on Building {
  id
  ...BuildingRow__Building
}
    ${BuildingRow__BuildingFragmentDoc}`;
export const LinkBuildingToCrmOrganisationDocument = gql`
    mutation LinkBuildingToCrmOrganisation($buildingId: ID!, $crmOrganisationId: ID!) {
  linkBuildingToCrmOrganisation(
    input: {buildingId: $buildingId, crmOrganisationId: $crmOrganisationId}
  ) {
    ok
  }
}
    `;
export type LinkBuildingToCrmOrganisationMutationFn = Apollo.MutationFunction<LinkBuildingToCrmOrganisationMutation, LinkBuildingToCrmOrganisationMutationVariables>;

/**
 * __useLinkBuildingToCrmOrganisationMutation__
 *
 * To run a mutation, you first call `useLinkBuildingToCrmOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBuildingToCrmOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBuildingToCrmOrganisationMutation, { data, loading, error }] = useLinkBuildingToCrmOrganisationMutation({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *      crmOrganisationId: // value for 'crmOrganisationId'
 *   },
 * });
 */
export function useLinkBuildingToCrmOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<LinkBuildingToCrmOrganisationMutation, LinkBuildingToCrmOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkBuildingToCrmOrganisationMutation, LinkBuildingToCrmOrganisationMutationVariables>(LinkBuildingToCrmOrganisationDocument, options);
      }
export type LinkBuildingToCrmOrganisationMutationHookResult = ReturnType<typeof useLinkBuildingToCrmOrganisationMutation>;
export type LinkBuildingToCrmOrganisationMutationResult = Apollo.MutationResult<LinkBuildingToCrmOrganisationMutation>;
export type LinkBuildingToCrmOrganisationMutationOptions = Apollo.BaseMutationOptions<LinkBuildingToCrmOrganisationMutation, LinkBuildingToCrmOrganisationMutationVariables>;